import $ from 'jquery';
export default class NewsLetterSignUp {
    init()
    {
        $(document).ready(() => { this.setup(); });
    }

    setup()
    {
        let me = this;
        me.initSelectors();
        me.initEvents();
    }
    initSelectors()
    {
        let me = this;
        me.$newsletterForm = $('#newsletterSignUp');
        me.$newsletterFormSection = $('.footer-section-signup');
    };

    initEvents()
    {
        let me = this;

        me.$newsletterForm.on('submit', function (e) {
            e.preventDefault();
            me.importFilterActions('signup', $(this));
        });
    }

    importFilterActions(action, actionValue)
    {
        let moduleFile = 'newsLetterSignUpActions';
        import('./' + moduleFile).then((Module) => {
            //remove the click events
            this.$newsletterForm.off("click");
            let module = new Module.default(action, actionValue);
            module.init();
        });
    }

}